import StyledLink from '../StyledLink'
import { STUDIO } from '../routes'
import type { Props } from '../types'

const LinkToStudio = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    isInlineLink={false}
    openInNewTab
    to={`/${STUDIO}`}
  >
    {children}
  </StyledLink>

export default LinkToStudio
